import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams, GridApi, RowNode } from 'ag-grid-community';

export class AbstractFilterComponent implements IFilterAngularComp {
  protected _gridApi: GridApi;
  protected _params: IFilterParams;
  protected _valueGetter: (rowNode: RowNode) => any;

  agInit(params: IFilterParams): void {
    this._gridApi = params.api;
    this._params = params;
    this._valueGetter = params.valueGetter;
  }

  isFilterActive(): boolean {
    return false;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return false;
  }

  getModel(): any {
    return {};
  }

  setModel(model: any): void {}
}
